import {Input} from 'antd'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import React, {useEffect, useState} from 'react'
import {NullAsDefault} from '../typedefs'
import {copyLocationParam, getRouteSearchParams} from "../../../envs/_current/history";

const SearchInput = (props) => (
  <Translate>
    {(t) => (
      <Input.Search
        name="keyword"
        allowClear={true}
        autoComplete="off"
        placeholder={t('type to search')}
        className="input-search-with-icon"
        {...props}
      />
    )}
  </Translate>
)

const SearchBinding = ({
  onSearch,
  Component = NullAsDefault,
  withProps = NullAsDefault,
  withInput = NullAsDefault,
  ...props
}) => {
  const [keyword, setKeyword] = useState(props.keyword)

  useEffect(() => {
    setKeyword(props.keyword)
  }, [props.keyword])

  const handleSearch = _.isFunction(onSearch)
    ? onSearch
    : (value) => {
        setKeyword(value)
      }

  const inputProps = {
    defaultValue: keyword,
    ...(withInput({ keyword }) ?? {}),
  }

  return (
    <Component
      {...props}
      {...withProps({
        search: {
          keyword,
          component: (
            <SearchInput
              {...inputProps}
              onSearch={handleSearch}
            />
          ),
        },
      })}
    />
  )
}

export const bindingSearch =
  (params) =>
  (Component = NullAsDefault) =>
    (
      <SearchBinding
        {...(params ?? {})}
        Component={Component}
        withProps={({ search }) => ({
          controls: {
            search,
          },
        })}
      />
    )

export const bindingRouteSearch =
  (params) =>
  (Component = NullAsDefault) =>
    (
      <NavigationContext.Consumer>
        {({ history, location }) => {
          const searchParam = getRouteSearchParams()
          const keyword = searchParam.get('keyword')
          const onSearch = (value) => {
            searchParam.set('keyword', value)
            history.replace({
              ...copyLocationParam(window.location ?? {}),
              search: '?' + searchParam.toString(),
            })
          }
          return bindingSearch({ ...(params ?? {}), keyword, onSearch })(
            Component
          )
        }}
      </NavigationContext.Consumer>
    )
